import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-full-page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-full-page__worm" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "row no-gutters" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "tile-container" }
const _hoisted_7 = { class: "basket-header-container" }
const _hoisted_8 = { class: "vertical-flow-header" }
const _hoisted_9 = { class: "logo" }
const _hoisted_10 = {
  key: 0,
  href: "//www.almbrand.dk",
  title: "Til Alm. Brand forside"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "logo__icon" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "col-12"
}
const _hoisted_14 = { class: "ContentAreaItem tile-wrapper" }
const _hoisted_15 = { class: "info-text" }
const _hoisted_16 = { class: "info-text__content" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = {
  key: 2,
  class: "vertical-app vertical-flow mt-4"
}
const _hoisted_20 = { class: "vertical-app vertical-flow ___contact" }
const _hoisted_21 = { class: "text-center vertical-flow__form__step ___contact-container" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "pb-5 ___text-left ___contact-container__contact" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "button-container text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToggleModalComponent = _resolveComponent("ToggleModalComponent")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_PageTitleComponent = _resolveComponent("PageTitleComponent")!
  const _component_BasketWidgetComponent = _resolveComponent("BasketWidgetComponent")!
  const _component_content_area = _resolveComponent("content-area")!
  const _component_MessageComponent = _resolveComponent("MessageComponent")!
  const _component_usabillaInPageComponent = _resolveComponent("usabillaInPageComponent")!
  const _component_buttonComponent = _resolveComponent("buttonComponent")!
  const _component_cookieFooter = _resolveComponent("cookieFooter")!
  const _directive_epi_edit = _resolveDirective("epi-edit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showSpinner)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_component_ToggleModalComponent),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.menuModel)
          ? (_openBlock(), _createBlock(_component_Menu, {
              key: 0,
              model: _ctx.menuModel
            }, null, 8, ["model"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(['vertical-flow-header-basket-page col-12', { app: _ctx.isLoggedInAsApp }])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_ctx.model && !_ctx.menuModel)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_10, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.model)
                ? (_openBlock(), _createBlock(_component_PageTitleComponent, {
                    key: 0,
                    class: _normalizeClass([{ 'no-preTitle': _ctx.isLoggedInAsApp }, 'page__title--tiles']),
                    preTitle: _ctx.preTitle,
                    mainTitle: _ctx.mainTitle
                  }, null, 8, ["class", "preTitle", "mainTitle"]))
                : _createCommentVNode("", true),
              (_ctx.cmsInit)
                ? (_openBlock(), _createBlock(_component_BasketWidgetComponent, {
                    key: 1,
                    showBasket: true,
                    forceOpen: true,
                    productName: undefined
                  }))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]),
        (_ctx.headerBadgeTxt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'vertical-app badge basket': _ctx.hasBadgeText })
                    }, [
                      _createElementVNode("div", {
                        innerHTML: _ctx.headerBadgeTxt,
                        class: _normalizeClass({ 'calculator-badge': _ctx.hasBadgeText })
                      }, null, 10, _hoisted_17)
                    ], 2)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createVNode(_component_content_area, {
            rootClass: "tile-wrapper",
            model: _ctx.model.mainArea,
            isTiles: true
          }, null, 8, ["model"]), [
            [_directive_epi_edit, 'MainArea']
          ])
        ]),
        (_ctx.cmsInit)
          ? (_openBlock(), _createBlock(_component_MessageComponent, {
              key: 1,
              useBasketModel: true,
              class: "page__content vertical-app vertical-flow"
            }))
          : _createCommentVNode("", true),
        (_ctx.usabillaProductBlock)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_usabillaInPageComponent, {
                class: _normalizeClass('productUsabilla'),
                model: _ctx.usabillaProductBlock
              }, null, 8, ["model"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.cmsInit && _ctx.cms.moreInsurancesBlockShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "page__content vertical-app mt-5 mb-5",
            style: _normalizeStyle({ maxWidth: _ctx.cms.moreInsurancesBlockMaxWidth })
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: "mb-4",
                  innerHTML: _ctx.cms.moreInsurancesBlockHeader
                }, null, 8, _hoisted_22),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.cms.moreInsurancesBlockText
                  }, null, 8, _hoisted_24),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_buttonComponent, {
                      btnClass: _ctx.cms.moreInsurancesBlockBtnClass,
                      label: _ctx.cms.moreInsurancesBlockBtnLabel,
                      href: _ctx.cms.moreInsurancesBlockBtnlink
                    }, null, 8, ["btnClass", "label", "href"])
                  ])
                ])
              ])
            ])
          ], 4))
        : _createCommentVNode("", true),
      (_ctx.cmsInit)
        ? (_openBlock(), _createBlock(_component_cookieFooter, {
            key: 1,
            class: "pb-4"
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}